import { useThreadNotifications } from "../../hooks/useThreadNotifications";
import { Button } from "../ui/button";
import { SettingsSection } from "./SettingsChrome";

export function ThreadNotificationSettings({ email }: { email: string }) {
  const { active, permission, requesting, error, enable, disable } = useThreadNotifications(email);

  return (
    <SettingsSection
      title="Thread notifications"
      description="Get a desktop notification when an agent finishes or needs your input in a thread you own or participate in."
    >
      <div className="flex flex-col items-start gap-3">
        <p className="text-sm text-muted-foreground">
          Keep Operators open in a browser tab. Notifications are skipped while you are viewing the
          thread. This preference applies to your account in this browser.
        </p>
        <Button
          variant="outline"
          disabled={requesting || permission === "unsupported" || permission === "denied"}
          onClick={() => {
            if (active) disable();
            else void enable();
          }}
        >
          {requesting
            ? "Enabling notifications..."
            : active
              ? "Disable notifications"
              : "Enable notifications"}
        </Button>
        <p role="status" className="text-xs text-muted-foreground">
          {error ??
            (permission === "unsupported"
              ? "Desktop notifications are not supported in this browser."
              : permission === "denied"
                ? "Notifications are blocked. Allow them in your browser's site settings."
                : active
                  ? "Notifications are on."
                  : "Notifications are off.")}
        </p>
      </div>
    </SettingsSection>
  );
}
